export const USER_MANAGEMENT_GET_ALL_USERS = 'USER_MANAGEMENT_GET_ALL_USERS'
export const USER_MANAGEMENT_ADD_USER = 'USER_MANAGEMENT_ADD_USER'
export const USER_MANAGEMENT_REMOVE_USER = 'USER_MANAGEMENT_REMOVE_USER'
export const USER_MANAGEMENT_UPDATE_USER_DETAILS = 'USER_MANAGEMENT_UPDATE_USER_DETAILS'
export const USER_MANAGEMENT_GET_USER_ROLES = 'USER_MANAGEMENT_GET_USER_ROLES'
export const USER_MANAGEMENT_HIDE_MODAL = 'USER_MANAGEMENT_HIDE_MODAL'
export const USER_MANAGEMENT_SHOW_MODAL = 'USER_MANAGEMENT_SHOW_MODAL'
export const USER_MANAGEMENT_RESET_USER_PASSWORD = 'USER_MANAGEMENT_RESET_USER_PASSWORD'